import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

export class CurrentUser {
  name: string;
  email: string;
  server: string;

  constructor(name: string, email: string, server: string) {
    this.name = name;
    this.email = email;
    this.server = server;
  }
}

/*
  Generated class for the AuthService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class AuthService {

  currentUser: CurrentUser;
  authenticated: boolean = false;

  public login(credentials) {
    if (credentials.email === null || credentials.password === null) {
      return Observable.throw("Please insert credentials");
    } else {
      return Observable.create(observer => {
        // At this point make a request to your backend to make a real check!
        let access = (credentials.password === "pass" && credentials.email === "email");
        this.authenticated = true;
        this.currentUser = new CurrentUser('Simon', 'saimon@devdactic.com', 'localhost');
        observer.next(access);
        observer.complete();
      });
    }
  }

  public register(credentials) {
    if (credentials.email === null || credentials.password === null) {
      return Observable.throw("Please insert credentials");
    } else {
      // At this point store the credentials to your backend!
      return Observable.create(observer => {
        observer.next(true);
        observer.complete();
      });
    }
  }

  public getUserInfo(): CurrentUser {
    return this.currentUser;
  }

  public logout() {
    return Observable.create(observer => {
      this.currentUser = null;
      this.authenticated = false;
      observer.next(true);
      observer.complete();
    });
  }

  public isAuthenticated(): boolean {
    let token = this.authenticated;
    if (token) {
      return true;
    }
    return false;
  }


}



// WEBPACK FOOTER //
// ./src/providers/auth-service.ts